module.exports = __webpack_public_path__ + "img/06.19a11b23.jpg";